// Auth service utilities
export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

export const getUser = () => {
  const userData = localStorage.getItem('user');
    
    // Check if userData exists and is not the string "undefined"
    if (!userData || userData === 'undefined') {
        return null; // or return a default user object
    }
    
    try {
        return JSON.parse(userData);
    } catch (error) {
        console.error('Failed to parse user data:', error);
        // Optionally clean up invalid data
        localStorage.removeItem('user');
        return null;
    }
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const removeUser = () => {
  localStorage.removeItem('user');
};

export const isAuthenticated = () => {
  const token = getToken();
  const user = getUser();
  return !!(token && user);
};

export const getUserRole = () => {
  const user = getUser();
  return user?.role || null;
};

export const hasRole = (role) => {
  const userRole = getUserRole();
  return userRole === role;
};

export const clearAuth = () => {
  removeToken();
  removeUser();
};

export const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};